// src/axios.js
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

console.log("🔍 API_BASE_URL in runtime:", API_BASE_URL);
console.log("🔍 NODE_ENV:", process.env.NODE_ENV);

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});